import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { message, Tooltip, Image } from 'antd';
import { reconciliationDetail } from './api';
import { BILL_STATUS } from './billConst';
import { amountToString } from '../../util/tool';
import { currency } from '../quotationProduct/formatNumber';
const printContainer = {
  padding: '32px 22px',
  pageBreakBefore: 'awlays'
};
const printTitle = {
  height: '50px',
  fontSize: '30px',
  fontWeight: 'bold',
  color: 'rgba(0, 0, 0, 0.85)',
  lineHeight: '50px',
  textAlign: 'center',
  paddingBottom: '54px'
};

const printTableWrapFragment = {};
const printTableWrap = {
  width: '100%',
  tableLayout: 'fixed'

};
const printTableWrapTr = {};
const printTableWrapTd = {
  height: '28px',
  fontSize: '12px',
  fontWeight: 400,
  color: 'rgba(0, 0, 0, 0.85)',
  lineHeight: '28px',
  margin: '8px 0',
};
const printOrderNumber = {
  fontSize: '12px',
  fontWeight: ' 400',
  color: ' rgba(0, 0, 0, 0.85)',
  lineHeight: '22px',
  padding: '16px 0',
};
const printTableContainer = {
  marginBottom: '20px',
  border: '1px solid',
  boxSizing: 'border-box'
};
const printTable = {
  width: '100%',
  borderCollapse: 'collapse',
};
const printTableThead = {
  background: '#EBEBEB',
  // borderBottom: '1px solid',
  boxSizing: 'border-box',
  margin: '-1px'
};
const printTableDescribe = {
  width: '100%',
  background: '#EBEBEB',
  padding: '2px 0',
  borderTop: '1px solid',
  boxSizing: 'border-box',
  fontSize: '12px'
};
const printTableItem = {
  padding: '5px',
  fontSize: '12px',
  width: '7%',
  textAlign: 'left'
};

const printTableItem2 = {
  width: '14%',
};
const printTableItem3 = {
  width: '33%',
  textAlign: 'left',
  padding: '12px 5px',
  fontSize: '12px',
};

const printTableWrapTdTitle = {
  margin: '10px 0'
};
const printTableWrapTdItemContainer = {
  fontSize: '12px',
  color: 'rgba(0, 0, 0, 0.85)',
  marginBottom: '10px',
};
const printTableWrapTdItemDesc = {
  color: 'rgba(0, 0, 0, 0.5)',
};
const printTableWrapTdItemDetail = {
  color: 'rgba(0, 0, 0, 0.5)',
};
export default function Print() {
  const params = useParams();
  const { id } = params;
  const [billInfo, setBillInfo] = useState({});
  const [templateType, setTemplateType] = useState(1); // 模版类型 1综合 2详细
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get('token');
  useEffect(() => {
    if (!window.localStorage.getItem('token')) {
      window.localStorage.setItem('token', token);
    }
    async function getReconciliationDetail() {
      const { data: { code, msg, data } } = await reconciliationDetail(({ reconciliation_no: id }));
      if (+code === 0) {
        setBillInfo(data);
        setTemplateType(data.template_type);
      } else {
        message.error(msg);
      }
    }
    getReconciliationDetail();
  }, [id, token]);

  const expense_details_render = (record) => {
    const { cost_amount, cost_mode, total_amount } = record;
    return currency(+cost_mode === 1 ? cost_amount : total_amount * cost_amount / 100);
  };

  return (
    <div className='print-container' style={printContainer}>
      <div className='print-content'>
        <div style={printTitle}>账单明细</div>
        <div style={printTableWrapFragment}>
          {templateType === 1 ? <table style={printTableWrap}>
            <tbody>
              <tr style={printTableWrapTr}>
                <td style={printTableWrapTd}>账单编号：{id}</td>
                <td style={printTableWrapTd}>账单状态：{BILL_STATUS[+billInfo?.status]}</td>
                <td style={printTableWrapTd}>结算金额含税-合计：{billInfo?.statement_amount ? `¥${amountToString(billInfo?.statement_amount)}` : '——'}</td>
              </tr>
              <tr>
                <td style={printTableWrapTd}>生成时间：{billInfo?.create_time || '——'}</td>
                <td style={printTableWrapTd}>付款时间：{billInfo?.pay_time || '——'}</td>
                <td style={printTableWrapTd}>收款时间：{billInfo?.finish_time || '——'}</td>
              </tr>
              <tr>
                <td style={printTableWrapTd}>取消时间：{billInfo?.cancel_time || '——'}</td>
              </tr>
              <tr style={{ verticalAlign: 'baseline' }}>
                <td>
                  <div style={printTableWrapTdTitle}>买家信息</div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>采购方编码：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.purchase_info?.company_id}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>采购方名称：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.purchase_info?.company_name || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>税号：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.purchase_info?.credit_code || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>开户行：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.purchase_info?.bank_name || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>银行账户：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.purchase_info?.bank_account || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>电话：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.purchase_info?.telephone || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>地址：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.purchase_info?.address || '--'}</span>
                  </div>
                </td>
                <td>
                  <div style={printTableWrapTdTitle}>卖家信息</div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>供应商编码：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.supplier_info?.company_id || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>供应商名称：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.supplier_info?.company_name || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>税号：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.supplier_info?.credit_code || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>开户行：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.supplier_info?.bank_name || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>银行账户：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.supplier_info?.bank_account || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>电话：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.supplier_info?.telephone || '--'}</span>
                  </div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={printTableWrapTdItemDesc}>地址：</span>
                    <span style={printTableWrapTdItemDetail}>{billInfo?.order_info?.[0]?.supplier_info?.address || '--'}</span>
                  </div>
                </td>
                <td>
                  <div style={printTableWrapTdTitle}>备注</div>
                  <div style={printTableWrapTdItemContainer}>
                    <span style={{ ...printTableWrapTdItemDetail, whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: billInfo?.desc }}></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table> :
            <table style={printTableWrap}>
              <tbody>
                <tr style={printTableWrapTr}>
                  <td style={printTableWrapTd}>账单编号：{id}</td>
                  <td style={printTableWrapTd}>账单状态：{BILL_STATUS[+billInfo?.status]}</td>
                  <td style={printTableWrapTd}>结算金额含税-合计：{billInfo?.statement_amount ? `¥${amountToString(billInfo?.statement_amount)}` : '——'}</td>
                </tr>
                <tr>
                  <td style={printTableWrapTd}>生成时间：{billInfo?.create_time || '——'}</td>
                  <td style={printTableWrapTd}>付款时间：{billInfo?.pay_time || '——'}</td>
                  <td style={printTableWrapTd}>收款时间：{billInfo?.finish_time || '——'}</td>
                </tr>
                <tr>
                  <td style={printTableWrapTd}>取消时间：{billInfo?.cancel_time || '——'}</td>
                </tr>
                <tr>
                  <td style={printTableWrapTd}>采购方编码：{billInfo?.purchase_id || '——'}</td>
                  <td style={printTableWrapTd}>采购方名称：{billInfo?.purchase_name || '——'}</td>
                </tr>
                <tr>
                  <td style={printTableWrapTd}>供应商编码：{billInfo?.supplier_id || '——'}</td>
                  <td style={printTableWrapTd}>供应商名称：{billInfo?.supplier_name || '——'}</td>
                </tr>
              </tbody>
            </table>}

        </div>
        <div style={printOrderNumber}>订单数量：{billInfo?.order_info?.length}</div>
        {
          (billInfo?.order_info || [])?.length ?
            (billInfo?.order_info || []).map((item, index) => {
              const { product_info = [], expense_details = [] } = item;
              return templateType === 1 ?
                <div style={printTableContainer} key={index}>
                  <table style={printTable}>
                    <thead style={printTableThead}>
                      <tr >
                        <th style={printTableItem}>商品编码</th>
                        <th style={{ ...printTableItem, ...printTableItem2 }}>商品</th>
                        <th style={printTableItem}>单位</th>
                        <th style={printTableItem}>收货数量</th>
                        <th style={printTableItem}><>商品综合单价<Tooltip title='商品平均成本，由商品单价+增值税费+平均费用计算得出'></Tooltip></></th>
                        <th style={printTableItem}><>商品综合小计<Tooltip title='商品综合小计，由商品小计+进口关税税费+增值税费+商品产生费用计算得出'></Tooltip></></th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        (product_info || []).map((subItem, subIndex) => {
                          return <tr key={subIndex}>
                            <td style={printTableItem}>{subItem?.sku_no}</td>
                            <td style={printTableItem}>{subItem?.sku_name}</td>
                            <td style={printTableItem}>{subItem?.sale_unit}</td>
                            <td style={printTableItem}>{subItem?.receive_number}</td>
                            <td style={printTableItem}>{currency(subItem?.receive_complete_sale_price)}</td>
                            <td style={printTableItem}>{currency(subItem?.receive_complete_total)}</td>
                          </tr>;
                        })
                      }
                    </tbody>
                  </table>
                  <table style={printTable}>
                    <tbody>
                      <tr style={{ borderTop: '1px solid #efefef', padding: 10, width: '100%', display: 'flex' }}>
                        <td style={{ lineHeight: 1.9, fontSize: 12, flex: 1 }}>预计到货时间:{item?.expected_date}</td>
                        <td style={{ lineHeight: 1.9, fontSize: 12, flex: 1 }}>批次号&柜号:{item?.container_no}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table style={printTableDescribe}>
                    <tbody>
                      <tr style={{ display: 'flex' }}>
                        <td style={{ flex: 1 }}>订单编号：{item?.order_no}</td>
                        <td style={{ flex: 1 }}>ERP订单编号：{item?.purchase_order_no}</td>
                        <td style={{ flex: 1 }}>结算金额含税(元)：{amountToString(item?.complete_amount_total)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                :
                <div style={printTableContainer} key={index}>
                  <table style={printTable}>
                    <thead style={printTableThead}>
                      <tr >
                        <th style={printTableItem}>商品编码</th>
                        <th style={{ ...printTableItem, ...printTableItem2 }}>商品</th>
                        <th style={printTableItem}>单位</th>
                        <th style={printTableItem}>单价(元)</th>
                        <th style={printTableItem}>商品订单数量</th>
                        <th style={printTableItem}>收货数量</th>
                        {/* <th style={printTableItem}>折扣金额</th> */}
                        {/* <th style={printTableItem}>实收金额未税(元)</th> */}
                        <th style={printTableItem}>税率</th>
                        {/* <th style={printTableItem}>税额(元)</th> */}
                        <th style={printTableItem}>实收金额含税(元)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        (product_info || []).map((subItem, subIndex) => {
                          return <tr key={subIndex}>
                            <td style={printTableItem}>{subItem?.sku_no}</td>
                            <td style={printTableItem}>{subItem?.sku_name}</td>
                            <td style={printTableItem}>{subItem?.sale_unit}</td>
                            <td style={printTableItem}>{amountToString(subItem?.sale_price)}</td>
                            <td style={printTableItem}>{subItem?.sale_number}</td>
                            <td style={printTableItem}>{subItem?.receive_number}</td>
                            {/* <td style={printTableItem}>{amountToString(subItem?.discount_amount)}</td> */}
                            {/* <td style={printTableItem}>{amountToString(subItem?.receive_amount)}</td> */}
                            <td style={printTableItem}>{subItem?.tax_rate}</td>
                            {/* <td style={printTableItem}>{amountToString(subItem?.tax_amount)}</td> */}
                            <td style={printTableItem}>{amountToString(subItem?.receive_complete_total)}</td>
                          </tr>;
                        })
                      }
                    </tbody>
                  </table>
                  <table style={printTable}>
                    <thead style={printTableThead}>
                      <tr>
                        <th style={printTableItem3}>费用项</th>
                        <th style={printTableItem3}>费用金额（元）</th>
                        <th style={printTableItem3}>费用备注</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        expense_details.length ?
                          (expense_details || []).map((subItem, subIndex) => {
                            return <tr key={subIndex}>
                              <td style={printTableItem}>{subItem?.cost_name}</td>
                              <td style={printTableItem}>{expense_details_render({ ...subItem, total_amount: item.total_amount })}</td>
                              <td style={printTableItem}>{subItem?.cost_explain}</td>
                            </tr>;
                          }) : <tr style={printTableItem}>
                            <td>无</td>
                          </tr>
                      }
                    </tbody>
                  </table>
                  <table style={printTableDescribe}>
                    <tbody>
                      <tr>
                        <td>订单编号：{item?.order_no}</td>
                        <td>ERP订单编号：{item?.purchase_order_no}</td>
                        <td>费用(元)：{amountToString(item?.freight_amount)}</td>
                        <td>结算金额含税(元)：{amountToString(item?.complete_amount_total)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>;
            })
            : null
        }
        <>
          {
            (templateType === 1) && <>
              {
                <div className='signature-item' style={{ display: 'flex' }}>
                  <div>采购方签字/盖章：</div>
                  {+billInfo.signature_type === 1 ? <Image width={200} src={billInfo.signature_file?.[0]?.url} preview={false} /> : null}
                </div>
              }
            </>
          }
        </>
      </div>
    </div>
  );
}